if (!customElements.get('volume-discount')) {
  class VolumeDiscount extends HTMLElement {
    constructor() {
      super();
      this.tiers = [];
      this.selectedIndex = -1;
      this.basePriceCents = 0;
      this.variantId = null;
    }

    connectedCallback() {
      this.basePriceCents = parseInt(this.dataset.basePriceCents) || 0;
      this.variantId = this.dataset.variantId;

      this.tierElements = this.querySelectorAll('.vd-tier');
      this.ctaButton = this.querySelector('.vd-cta');

      this.tierElements.forEach((tier, index) => {
        this.tiers.push({
          quantity: parseInt(tier.dataset.quantity) || 1,
          discount: parseFloat(tier.dataset.discount) || 0,
          isPlus: tier.dataset.plus === 'true',
          freeVariantId: tier.dataset.freeVariantId || null,
        });

        tier.addEventListener('click', (e) => {
          if (e.target.closest('.vd-tier__qty-btn') || e.target.closest('.vd-tier__qty-input')) return;
          this.selectTier(index);
        });
      });

      // Quantity controls
      this.querySelectorAll('.vd-tier__qty-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const tierEl = btn.closest('.vd-tier');
          const index = [...this.tierElements].indexOf(tierEl);
          const input = tierEl.querySelector('.vd-tier__qty-input');
          const min = parseInt(input.min) || 1;
          let val = parseInt(input.value) || min;

          if (btn.dataset.action === 'plus') val++;
          else if (btn.dataset.action === 'minus' && val > min) val--;

          input.value = val;
          this.tiers[index].quantity = val;
          this.selectTier(index);
          this.updatePrices(index);
        });
      });

      this.querySelectorAll('.vd-tier__qty-input').forEach((input) => {
        input.addEventListener('change', () => {
          const tierEl = input.closest('.vd-tier');
          const index = [...this.tierElements].indexOf(tierEl);
          const min = parseInt(input.min) || 1;
          let val = parseInt(input.value) || min;
          if (val < min) val = min;
          input.value = val;
          this.tiers[index].quantity = val;
          this.updatePrices(index);
          this.updateCTA();
        });
      });

      if (this.ctaButton) {
        this.ctaButton.addEventListener('click', () => this.addToCart());
      }

      // Listen for variant changes — hide widget if non-30er variant selected
      this.targetVariantId = this.dataset.targetVariantId || null;

      // variant:change is dispatched on the product form, not document — use pubsub instead
      if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data?.variant;
          if (!variant) return;

          if (this.targetVariantId) {
            const isTarget = String(variant.id) === String(this.targetVariantId);
            this.style.display = isTarget ? '' : 'none';
          } else {
            this.basePriceCents = variant.price;
            this.updateAllPrices();
          }
        });
      }

      // Auto-select last (best value) tier
      if (this.dataset.autoSelect !== 'false' && this.tierElements.length > 0) {
        this.selectTier(this.tierElements.length - 1);
      }
    }

    selectTier(index) {
      this.selectedIndex = index;
      this.tierElements.forEach((t, i) => t.classList.toggle('is-active', i === index));
      this.updateCTA();
    }

    formatMoney(cents) {
      const euros = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + euros;
    }

    updatePrices(index) {
      const tier = this.tiers[index];
      const tierEl = this.tierElements[index];
      const qty = tier.quantity;
      const totalCents = this.basePriceCents * qty;
      const discountedCents = Math.round(totalCents * (1 - tier.discount / 100));

      const priceEl = tierEl.querySelector('.vd-tier__price');
      const compareEl = tierEl.querySelector('.vd-tier__compare-price');

      if (priceEl) priceEl.textContent = this.formatMoney(discountedCents);
      if (compareEl) compareEl.textContent = this.formatMoney(totalCents);
    }

    updateAllPrices() {
      this.tiers.forEach((_, i) => this.updatePrices(i));
    }

    updateCTA() {
      if (!this.ctaButton || this.selectedIndex < 0) return;
      const tier = this.tiers[this.selectedIndex];
      const qty = tier.quantity;
      const discount = tier.discount;
      this.ctaButton.textContent = `Füge ${qty} hinzu | spare ${discount}%`;
      this.ctaButton.disabled = false;
    }

    async addToCart() {
      if (this.selectedIndex < 0 || !this.variantId) return;

      const tier = this.tiers[this.selectedIndex];
      const items = [{ id: parseInt(this.variantId), quantity: tier.quantity }];

      if (tier.freeVariantId) {
        items.push({ id: parseInt(tier.freeVariantId), quantity: 1 });
      }

      this.ctaButton.disabled = true;
      this.ctaButton.textContent = '...';

      try {
        // Add items to cart
        const response = await fetch(theme.routes.cart_add_url, {
          ...theme.utils.fetchConfig('javascript'),
          body: JSON.stringify({ items }),
        });

        const parsedState = await response.json();

        if (parsedState.status) {
          console.error('Volume discount add to cart error:', parsedState.description);
          return;
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: parsedState },
        }));

        // Refresh cart drawer content and open it
        // Uses cart:refresh which fetches section HTML directly — most reliable approach
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { open: true },
        }));
      } catch (err) {
        console.error('Volume discount add to cart error:', err);
        // Still try to open cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.show();
      } finally {
        this.updateCTA();
      }
    }
  }

  customElements.define('volume-discount', VolumeDiscount);
}
